import React, {FC} from 'react'
import classnames from 'classnames'
import StylesType from '@/types/StylesType'
import {Modal} from 'antd'
import Tabs from './tabs'
import DeviceList from './DeviceList'
import './style/style.less'

export interface RenewalTypes {
  visible?: boolean
  productList?: any[];
  deviceList?: any[];
  productId?: string;
  changeActive?: (id: string, index: number) => void
  productIds?: any[];
  onChange?: (arr: any[]) => void
  onOk?:() => void // 点击确认回调
  onCancel?: () => void // 点击遮罩层或右上角叉或取消按钮的回调
  onAllSelect?: (bool: boolean) => void
  getDeviceName: (cid: string) => string
}

type RenewalProps = StylesType & RenewalTypes

const Renewal: FC<RenewalProps> = props => {
  const {visible = false} = props
  const {className, prefixCls = 'gc_Renewal_modal_', productList = [], deviceList, changeActive, productIds = [], onChange, onOk, onCancel, onAllSelect, getDeviceName} = props
  return (
    <Modal
      visible={visible}
      title='续费云手机'
      width={1077}
      className={classnames(prefixCls + 'box', className)}
      onOk={onOk}
      onCancel={onCancel}
      maskClosable={false}
    >
      <div className={classnames()}>
        <Tabs dataSource={productList} name='productId' tab='productName' onChange={changeActive}>
          <DeviceList
            productIds={productIds}
            onChange={onChange}
            deviceList={deviceList}
            indeterminate={true}
            onAllSelect={onAllSelect}
            getDeviceName={getDeviceName}
          ></DeviceList>
        </Tabs>
      </div>
    </Modal>
  )
}
export default Renewal


